const TERMS_URL = "https://www.itau.com.br/assets/dam/publisher/01_itau/09_Seguros/01_campanha1/assets/termos/termos_condicoes_2021_05.pdf";
const TERMS_TEXT = "os dados inseridos por você a partir de agora serão compartilhados com as empresas parceiras e utilizados na cotação e, se aprovada, na contratação do produto escolhido";
const PAYMENT_TERMS_TEXT = "Declaro que li e estou de acordo com as condições gerais, resumo do plano e com os termos de uso.";

export {
    TERMS_TEXT,
    TERMS_URL,
    PAYMENT_TERMS_TEXT,
}
